/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import {TouchableOpacity, ViewStyle} from 'react-native';
import {Icon} from 'react-native-elements';

interface AppProps {
  color?: string;
  iconStyle?: ViewStyle;
  Component?: any;
  disabled?: boolean;
  name: string;
  disabledStyle?: ViewStyle;
  onPress?(): void;
  onLongPress?(): void;
  underlayColor?: string;
  reverse?: boolean;
  raised?: boolean;
  containerStyle?: ViewStyle;
  reverseColor?: string;
  type?: string;
  size?: number;
}

const hitSlop = {top: 20, right: 20, left: 20, bottom: 20};

export const IconV = (props: AppProps): JSX.Element => {
  return <Icon {...props} hitSlop={hitSlop} />;
};

IconV.defaultProps = {
  Component: TouchableOpacity,
  underlayColor: 'transparent',
} as Partial<AppProps>;
